import { useState } from "react";
import { TimeRange } from "../shared/types/dashboard";

interface UseTimeRangeReturn {
  timeRange: TimeRange;
  customStartDate: string;
  customEndDate: string;
  handleTimeRangeChange: (range: TimeRange) => void;
  setCustomStartDate: (date: string) => void;
  setCustomEndDate: (date: string) => void;
}

export const useTimeRange = (): UseTimeRangeReturn => {
  const [timeRange, setTimeRange] = useState<TimeRange>("today");
  const [customStartDate, setCustomStartDate] = useState<string>("");
  const [customEndDate, setCustomEndDate] = useState<string>("");

  const handleTimeRangeChange = (range: TimeRange) => {
    setTimeRange(range);
    if (range !== "custom") {
      setCustomStartDate("");
      setCustomEndDate("");
    }
  };

  return {
    timeRange,
    customStartDate,
    customEndDate,
    handleTimeRangeChange,
    setCustomStartDate,
    setCustomEndDate,
  };
};
